var StitchAppClientInfo = (function () {
    function StitchAppClientInfo(clientAppId, dataDirectory, localAppName, localAppVersion) {
        this.clientAppId = clientAppId;
        this.dataDirectory = dataDirectory;
        this.localAppName = localAppName;
        this.localAppVersion = localAppVersion;
    }
    return StitchAppClientInfo;
}());
export default StitchAppClientInfo;
//# sourceMappingURL=StitchAppClientInfo.js.map